import { PaletteOptions } from '@mui/material/styles';

export const palette: PaletteOptions = {
  primary: {
    main: '#0166b3',
    dark: '#004785',
    light: '#1976d2',
    '100': '#0166b31a',
    '200': '#D7EBFF',
  },
  secondary: {
    main: '#cce0f0',
  },
  warning: {
    main: '#FF9800',
    light: '#FFED8A',
  },
  background: {
    default: '#F7FAFD',
    paper: '#e7eaef',
    tableHeader: '#FCFDFD',
  },
  error: {
    main: '#de6363',
  },
  covenantStatus: {
    success: '#1B873F',
    warning: '#E28704',
    error: '#D92D20',
  },
  text: {
    primary: '#030609',
    secondary: '#666666',
    muted: '#4B5563',
  },
  grey: {
    '100': '#c5c5c5',
    '200': '#c5c5c533',
    '400': '#c5c5c566',
    '800': '#c5c5c5cc',
    additionalGrey: '#BDBDBD',
    infoIconGrey: '#808686',
    placeholderGrey: '#3d3d3d66',
    disabled: '#f7f7f7',
  },
  common: {
    white: '#ffffff',
    black: '#000000',
  },
  border: {
    subtle: '#D9D9D9',
  },
  shadow: {
    modal: '7px 7px 40px 0 rgba(217, 217, 217, 0.8)',
    dialog: '0 12px 32px rgb(15 23 42 / 0.18)',
    menu: '0 8px 24px rgb(15 23 42 / 0.14)',
    tooltip: '0 4px 12px rgb(15 23 42 / 0.16)',
    tooltipArrow: '-2px -2px 4px rgb(15 23 42 / 0.04)',
    surface: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  },
};
